import {NgModule} from '@angular/core';
import {RouterModule, Routes} from "@angular/router";
import {LoginComponent} from "./components/login/login.component";
import {SearchComponent} from "./components/search/search.component";
import {GameUserComponent} from "./components/game-user/game-user.component";
import {DistrictComponent} from "./components/district/district.component";
import {ClubComponent} from "./components/club/club.component";
import {WebsiteUserComponent} from "./components/website-user/website-user.component";
import {HackAddUserComponent} from "./components/hack-add-user/hack-add-user.component";


const routes: Routes = [
  {path: 'login', component: LoginComponent},
  {path: 'search', component: SearchComponent},
  {path: 'club', component: ClubComponent},
  {path: 'district', component: DistrictComponent},
  {path: 'gameUser', component: GameUserComponent},
  {path: 'websiteUser', component: WebsiteUserComponent},
  {path: 'hackAddUser', component: HackAddUserComponent},
  {path: '', component: SearchComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})


export class AppRoutingModule {

}
